<template>
<div :class=div_classes>

<select :name="name" v-model="value" @change="change">
<option v-for="item in items" :key="item.value" :value="item.value"
selected
:selected="item.value===default_val ? 'selected' : ''" >

     {{ item.label }} 
</option>

</select>
</div>
</template>

<script>
export default {
  name: 'SelectList',
  
    data () {
    return {
        value: "",
        }
    },
    created : function(){
        this.value = this.default_val
    },
    props: {
        default_val : String,
        div_classes : String,
        name : String,
        items : {
            type: Array,
            default: function () {
                return []
            }
        }
    },
    watch: {
        default_val : function(){
            this.value = this.default_val
        }
    },
    methods : {
        change : function(){
            this.$emit('input', this.value)
        }
    }
    
}
</script>

<style scoped>
select {
    width: 100%;
    padding: 2px;
    border-radius: .7em;
    background-color: #fff;
    height: 3em;
    padding: .5em 1em .2em 1em;
    border: 1px solid #fff;
    margin-top: 1px;
    
    background-color: rgba(38,85,139,1);
    color: #fff;
    
    
}

</style>
